import React, { useState } from "react";
import axios from "axios";
import { IonPage, IonContent, IonHeader, IonToast } from "@ionic/react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { baseUrl, config, requestID } from "../../common/utils";
import { Add } from "@mui/icons-material";
import { useBusinessContext } from "../../context/business-context";
import { useHistory } from "react-router-dom";

const CreateBranch: React.FC = () => {
    const { selectedBusinessId , selectedBusinessName, selectedBusinessTypeName} = useBusinessContext();
   
  const [branchName, setBranchName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
     const history = useHistory();

  const handleCreateBranch = async () => {
    if (!branchName || !address || !phone || !email) {
      setMessage("Please fill in all fields");
      return;
    }
    
    setLoading(true);
    setMessage("");
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("name", branchName);
    formData.append("address", address);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("business_id", selectedBusinessId);
    console.log("Form Data:", formData);
    
    try {
      const response = await axios.post(baseUrl() + "businesss/addBranch", formData, config);
      console.log("Branch Created:", response);
      setMessage("Branch created successfully!");
      setBranchName("");
      setAddress("");
      setPhone("");
      setEmail("");
    } catch (error) {
      console.error("Error creating branch:", error);
      setMessage("Failed to create branch. Please try again.");
    } finally {
        setLoading(false);
       history.push("/folder/branches/:idx");
    }
  };
  const goBack = () => {
    window.history.back();
  }
  return (
    <IonPage className="pushDown">
    

    <IonHeader style={{ backgroundColor: "white" }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
    <Typography variant="h6" sx={{ color: "chocolate" }}>
      {selectedBusinessName?.toUpperCase() || "Business Management"} - Create Branch
    </Typography>
    <Button variant="contained" color="secondary" onClick={goBack}>
      Go Back
    </Button>
  </div>
</IonHeader>

      <IonContent className="ion-padding">
        <Box sx={{ maxWidth: 400, margin: "auto" }}>
          <TextField
            fullWidth
            label="Branch Name"
            variant="outlined"
            value={branchName}
            onChange={(e) => setBranchName(e.target.value)}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            fullWidth
            label="Branch Location"
            variant="outlined"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            sx={{ marginBottom: 2 }}
          />
                  <TextField
                      fullWidth
                      label="Phone"
                      variant="outlined"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      sx={{ marginBottom: 2 }}
                  />
                    <TextField
                        fullWidth
                        label="Email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      sx={{ marginBottom: 2 }}
                    />
          {/* {message && <Typography color="error">{message}</Typography>} */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateBranch}
            disabled={loading}
            fullWidth
          >
            {loading ? "Creating..." : "Create Branch"}
          </Button>
              </Box>
              <IonToast
                    isOpen={message !== ""}
                    onDidDismiss={() => setMessage("")}
                    message={message}
                    duration={2000}
                    position="bottom"
                  color={message === "Branch created successfully!" ? "success" : "danger"}
                />
      </IonContent>
    </IonPage>
  );
};

export default CreateBranch;
